import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { ConfigProvider } from "@/context/ConfigContext";
import Home from "@/pages/Home";
import OwnerPage from "@/pages/OwnerPage";
import TenantPage from "@/pages/TenantPage";
import ClubPage from "@/pages/ClubPage";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <ConfigProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ev-sahibi" element={<OwnerPage />} />
            <Route path="/kiraci" element={<TenantPage />} />
            <Route path="/ev-sahipleri-klubu" element={<ClubPage />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </ConfigProvider>
    </LanguageProvider>
  );
}

export default App;
